
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-optout-instructions/meta",
      function () {
        return require("private-next-pages/ai-optout-instructions/meta/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-optout-instructions/meta"])
      });
    }
  